export default __webpack_public_path__ + "static/photo11usluge-8f86b7a762fe4a7a59f92f29a1982d7f.png";